/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Activity_Period_MonthInputs */

const en_analytics_activity_period_month = /** @type {(inputs: Analytics_Activity_Period_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month`)
};

const de_analytics_activity_period_month = /** @type {(inputs: Analytics_Activity_Period_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monat`)
};

const fr_analytics_activity_period_month = /** @type {(inputs: Analytics_Activity_Period_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mois`)
};

const es_analytics_activity_period_month = /** @type {(inputs: Analytics_Activity_Period_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes`)
};

const it_analytics_activity_period_month = /** @type {(inputs: Analytics_Activity_Period_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mese`)
};

const nl_analytics_activity_period_month = /** @type {(inputs: Analytics_Activity_Period_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maand`)
};

const pl_analytics_activity_period_month = /** @type {(inputs: Analytics_Activity_Period_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miesiąc`)
};

const fi_analytics_activity_period_month = /** @type {(inputs: Analytics_Activity_Period_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuukausi`)
};

const da_analytics_activity_period_month = /** @type {(inputs: Analytics_Activity_Period_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Måned`)
};

const sv_analytics_activity_period_month = /** @type {(inputs: Analytics_Activity_Period_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månad`)
};

/**
* | output |
* | --- |
* | "Month" |
*
* @param {Analytics_Activity_Period_MonthInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_activity_period_month = /** @type {((inputs?: Analytics_Activity_Period_MonthInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Activity_Period_MonthInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_activity_period_month(inputs)
	if (locale === "fr") return fr_analytics_activity_period_month(inputs)
	if (locale === "es") return es_analytics_activity_period_month(inputs)
	if (locale === "it") return it_analytics_activity_period_month(inputs)
	if (locale === "nl") return nl_analytics_activity_period_month(inputs)
	if (locale === "pl") return pl_analytics_activity_period_month(inputs)
	if (locale === "fi") return fi_analytics_activity_period_month(inputs)
	if (locale === "da") return da_analytics_activity_period_month(inputs)
	if (locale === "sv") return sv_analytics_activity_period_month(inputs)
	return en_analytics_activity_period_month(inputs)
});